import React from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { WhoYouAre } from '../components/WhoYouAre';
import { TransformationMap } from '../components/TransformationMap';
import { Programs } from '../components/Programs';
import { Mentorias } from '../components/Mentorias';
import { AlmaEnExpansion } from '../components/AlmaEnExpansion';
import { FreeResources } from '../components/FreeResources';
import { Community } from '../components/Community';
import { TransformationStories } from '../components/TransformationStories';
import { AboutDaniel } from '../components/AboutDaniel';
import { DigitalStore } from '../components/DigitalStore';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-cream" data-id="element-350">
      <Navigation data-id="element-351" />
      <main data-id="element-352">
        <Hero data-id="element-353" />
        <WhoYouAre data-id="element-354" />
        <TransformationMap data-id="element-355" />
        <Programs data-id="element-356" />
        <Mentorias data-id="element-357" />
        <AlmaEnExpansion data-id="element-358" />
        <FreeResources data-id="element-359" />
        <Community data-id="element-360" />
        <TransformationStories data-id="element-361" />
        <AboutDaniel data-id="element-362" />
        <DigitalStore data-id="element-363" />
      </main>
      <Footer data-id="element-364" />
    </div>;
}